import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logger } from '@/utils/logger';

interface NavigationEvent {
  from: string;
  to: string;
  timestamp: number;
  success: boolean;
  error?: string;
}

export const useNavigationAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track successful navigation
    const navigationEvent: NavigationEvent = {
      from: document.referrer || 'direct',
      to: location.pathname,
      timestamp: Date.now(),
      success: true
    };

    logger.info('Navigation successful', navigationEvent);
  }, [location]);

  const trackNavigationError = (error: string, targetRoute: string) => {
    const errorEvent: NavigationEvent = {
      from: location.pathname,
      to: targetRoute,
      timestamp: Date.now(),
      success: false,
      error
    };

    logger.error('Navigation failed', errorEvent);
  };

  const trackRouteGeneration = (routeType: string, success: boolean, details?: any) => {
    logger.info('Route generation', {
      routeType,
      success,
      currentPath: location.pathname,
      details,
      timestamp: Date.now()
    });
  };

  return {
    trackNavigationError,
    trackRouteGeneration
  };
};